module.exports = __webpack_public_path__ + "assets/img/00005.180e050b.png";